import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';


export const client = sanityClient({
  projectId: 'saw4vstx',
  dataset: 'production',
  apiVersion: '2023-05-02',
  useCdn: true,
  token: process.env.PROJECT_TOKEN,
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);





